import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import { Link, useNavigate } from 'react-router-dom';
import L from 'leaflet';
import { Departamento, Municipio, Distrito, Empresa, EmpresaUsuarios, getSession, PuntoCentral } from '../utils/utils';
import axios from 'axios';
import Swal from 'sweetalert2';
import ubicacionForm from '../assets/images/ubicacionForm.png';

const customIcon = new L.Icon({
	iconUrl: ubicacionForm, // Ruta de la imagen
	iconSize: [41, 41], // Tamaño del ícono
	iconAnchor: [12, 41], // Punto de anclaje del ícono
	popupAnchor: [1, -34], // Punto de anclaje del popup
	shadowSize: [41, 41], // Tamaño de la sombra
});

function FormularioDatosTrabajador() {
	const navigate = useNavigate();

	const savedValues = JSON.parse(localStorage.getItem('FormDatosTrabajador')) || {
		nombre: '',
		id_empresa: '',
		sexo: '',
		nacimiento: '',
		dui: '',
		correo: '',
		departamento: '',
		municipio: '',
		distrito: '',
		latitud: '',
		longitud: '',
		area_trabajo: '',
		nombre_conyugue: '',
		nacimiento_conyugue: '',
		sexo_conyugue: '',
		trabaja_conyugue: '',
		empresa_conyugue: '',
		embarazo_conyugue: '',
		parto_conyugue: '',
		bebe_conyugue: '',
		hijos_conyugue: '',
	};

	const { register, handleSubmit, watch, reset, formState: { errors }, setError, clearErrors, getValues } = useForm();

	const valores = watch();
	let totalErrors = Object.keys(errors).length;

	const [departamento, setDepartamento] = useState([]);
	const [municipios, setMunicipios] = useState([]);
	const [distritos, setDistritos] = useState([]);
	const [empresa, setEmpresa] = useState([]);
	const [centro, setCentro] = useState([])
	const [selectedPosition, setSelectedPosition] = useState(null);
	const [location, setLocation] = useState(null);

	const [userInfo, setUserInfo] = useState({
		email: null,
		name: null,
		company: null,
		role: null
	});

	async function getInfo() {
		let session = await getSession();
		
		if (session !== null) {
			setUserInfo(session);
			return;
		}

		// navigate("/");

		return;
	}

	useEffect(
		function () {
			getInfo();
		}
		, []
	)

	async function getDepartamento() {
		setDepartamento(await Departamento());
	}

	async function getEmpresa() {
		setEmpresa(await EmpresaUsuarios());
	}

	async function handleCentro(element) {

		if (element.target.value !== "") {
			let centroData = await PuntoCentral(element.target.value);
			if (centroData) {
				setCentro(centroData);
			} else {
				setCentro(
					{
						latitude: "13.79459900",
						longitude: "-88.93000000"
					});
			}
			return;
		}

		setCentro(
			{
				latitude: "13.79459900",
				longitude: "-88.93000000"
			});
	}

	async function handleMunicipio(element) {
		if (element.target.value !== "") {
			let municipioData = await Municipio(element.target.value);
			// console.log(municipioData);
			setMunicipios(municipioData);
			return;
		}

		setMunicipios([]);
		return;
	}

	async function handleDistrito(element) {
		if (element.target.value !== "") {
			let distritoData = await Distrito(element.target.value);
			// console.log(distritoData);
			setDistritos(distritoData);
			return;
		}

		setDistritos([]);
		return;
	}

	const validarDui = (value) => {
		const cleanedValue = value.replace(/[^0-9-]/g, "").replace(/\s/g, "");

		const onlyNumbers = cleanedValue.replace(/-/g, "");
		if (onlyNumbers.length > 9) return value;

		let formattedValue = onlyNumbers.slice(0, 8);
		if (onlyNumbers.length > 8) {
			formattedValue += "-" + onlyNumbers.slice(8, 9);
		}

		// Validación de longitud (8 dígitos + 1 guion)
		if (onlyNumbers.length === 9) {
			clearErrors("dui"); // Limpia el error si es válido
		} else {
			setError("dui", {
				type: "manual",
				message: "El DUI debe tener 9 caracteres (8 números + 1 guion).",
			});
		}
		return formattedValue;
	}

	const CenterMap = ({ position }) => {
		const map = useMap();
		useEffect(() => {
			if (position) {
				map.flyTo(position, 12); // Cambia el centro del mapa con una animación
			}
		}, [position, map]);
		return null;
	};

	const SelectLocation = ({ setSelectedPosition }) => {
		useMapEvents({
			click(e) {
				console.log("Coordenadas seleccionadas: " + e.latlng)
				setSelectedPosition(e.latlng); // Guarda la latitud y longitud
			},
		});
		return null;
	};

	async function sendData(e) {
		const tieneHijos = getValues("hijos_conyugue")
		// console.log(e);
		let form = {
			datos_colaborador: e
		}
		// console.log(form);
		if (!selectedPosition) {
			setLocation(true);
			return;
		} else {
			setLocation(false);
		}

		form.datos_colaborador.latitud = selectedPosition.lat;
		form.datos_colaborador.longitud = selectedPosition.lng;
		sessionStorage.setItem("Empleado-Info", JSON.stringify(form))
		if (tieneHijos === 'no') {
			let uri = process.env.REACT_APP_API_URL + 'formularios';

			let config = {
				headers: {
					'Content-Type': 'multipart/form-data',
					'Accept': 'application/json'
				}
			};

			try {
				let response = await axios({
					method: 'POST',
					url: uri,
					data: form,
					headers: config.headers
				});
				// console.log(response);
				Swal.fire(
					{
						title: 'Registro exitoso',
						text: 'Datos enviados correctamente',
						icon: 'success',
						confirmButtonText: 'Aceptar'
					}
				)
					.then(function () {
						localStorage.removeItem("FormDatosTrabajador");
						localStorage.removeItem("FormHijos");
						localStorage.removeItem("FormServicio");

						if (userInfo?.role) {
							navigate("/Inicio")
						} else {
							navigate("/")
						}
					})
			} catch (error) {
				console.log(error);
			}
		} else {
			navigate("/DatosHijos")
		}
	}

	// Detectar cambios en cualquier campo
	useEffect(() => {
		console.log(valores, "valores");
		localStorage.setItem('FormDatosTrabajador', JSON.stringify(valores));
	}, [valores]);

	useEffect(function () {
		const loadData = async () => {
			await getDepartamento();
			await getEmpresa();

			// Solo después de cargar los datos, verifica y establece los valores
			if (savedValues.departamento) {
				const municipiosData = await Municipio(savedValues.departamento);
				setMunicipios(municipiosData);

				if (savedValues.municipio) {
					const distritosData = await Distrito(savedValues.municipio);
					setDistritos(distritosData);
				}

				const centroData = await PuntoCentral(savedValues.departamento);
				setCentro(centroData || {
					latitude: "13.79459900",
					longitude: "-88.93000000"
				});
			}

			// Finalmente, resetea los valores
			reset(savedValues);
		};

		loadData();
	}, [reset]);
	console.log(totalErrors, "totalErrors");
	return (
		<div className="mt-6 w-full font-bold p-10">
			<h1 className="text-3xl md:text-4xl text-custom-main mb-1">Información general del colaborador</h1>
			<p className='font-normal text-sm md:text-base mb-2'>Completa todos los campos solicitados, como Nombre, Sexo, Área de trabajo, DUI y cualquier otro detalle relevante, asegurándote de que la información sea precisa y esté actualizada.</p>
			<br />
			<form onSubmit={handleSubmit(sendData)} className={`flex flex-col md:ml-5 w-auto ${totalErrors > 0 ? 'form-errors' : ''}`} id="formulario">
				<div className="flex flex-col md:flex-row px-2">
					<div className="md:mr-2 w-auto md:w-1/2 mb-2">
						<label htmlFor='nombre' className="p-1">Nombre del colaborador</label>
						<input placeholder="Nombre del colaborador" 
							className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.nombre ? 'border-red-600' : ''}`} 
							type="text" 
							{...register("nombre", {
								required: {
									value: true,
									message: "El nombre es requerido"	
								},
								pattern: {
									value: /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g,
									message: "El nombre introducido no es correcto"
								}
							})} 
						/>
						{errors.nombre && <span className='text-red-600'>{errors.nombre.message}</span>}
					</div>
					<div className="md:mx-2 w-auto md:w-1/2 mb-2">
						<label htmlFor='empresa' className="p-1">
							Nombre de la empresa o sucursal
						</label>
						<select value={
							getValues("id_empresa")
						} className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg ${errors.id_empresa ? 'border-red-600' : ''}`} {...register("id_empresa", { required: "Elige una empresa" })}>
							<option value="">  Empresa / Sucursal
							</option>
							{empresa.map(function (item, index) {
								return (
									<option key={index} value={item.nit_empresa}>{item.nombre_empresa}</option>
								);
							})}
						</select>
						{errors.id_empresa && <span className='text-red-600'>{errors.id_empresa.message}</span>}
					</div>
				</div>
				<div className="flex flex-col md:flex-row px-2">
					<div className="md:mr-2 w-auto md:w-1/4 mb-2">
						<label htmlFor='sexo' className="p-1">Sexo</label>
						<select className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg ${errors.sexo ? 'border-red-600' : ''}`} {...register("sexo", { required: "Selecciona tu sexo" })}>
							<option value="">Selecciona el sexo</option>
							<option value="masculino">Masculino</option>
							<option value="femenino">Femenino</option>
						</select>
						{errors.sexo && <span className='text-red-600'>{errors.sexo.message}</span>}
					</div>
					<div className="md:mx-2 w-auto md:w-1/4 mb-2">
						<label htmlFor='nacimiento' className="p-1">Fecha de Nacimiento</label>
						<input id="" className={`w-full border-2 p-3 text-lg h-2/3 font-normal bg-[#D1ECF2] rounded-lg ${errors.nacimiento ? 'border-red-600' : ''}`} type="date" {...register("nacimiento", {
							required: {
								value: true,
								message: "La fecha de nacimiento es requerida"
							},
							validate: value => {
								const nacimiento = new Date(value);
								const fechaActual = new Date();
								const edad = fechaActual.getFullYear() - nacimiento.getFullYear();
								return edad >= 18 || "Debes ser mayor de edad"
							}
						})} />
						{errors.nacimiento && <span className='text-red-600'>{errors.nacimiento.message}</span>}
					</div>
					<div className="md:mx-2 w-auto md:w-1/2 mb-2">
						<label htmlFor='direccion' className="p-1">Dirección de residencia:</label>
						<input placeholder="Ingresa tu dirección" className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg ${errors.direccion ? 'border-red-600' : ''}`} type="text" {...register("direccion", { required: "Escribe tu dirección de residencia" })} />
						{errors.direccion && <span className='text-red-600'>{errors.direccion.message}</span>}
					</div>
				</div>
				<div className="flex flex-col md:flex-row px-2 justify-between w-auto">
					<div className='w-auto md:w-1/2 md:mr-2 mb-2'>
						<div className="w-auto mb-2">
							<label className="p-1">Departamento</label>
							<select className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg ${errors.departamento ? 'border-red-600' : ''}`} {...register("departamento", { required: "Selecciona tu departamento de residencia" })}
								onChange={(e) => {
									handleMunicipio(e)
									handleCentro(e)
								}
								}
							>
								<option value="">Seleccione su departamento</option>
								{departamento.map(function (item, index) {
									return (
										<option key={index} value={item.id}>{item.name}</option>
									);
								})}
							</select>
							{errors.departamento && <span className='text-red-600'>{errors.departamento.message}</span>}
						</div>
						<div className="w-auto mb-2">
							<label className="p-1">Municipio</label>
							<select className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg ${errors.municipio ? 'border-red-600' : ''}`} {...register("municipio", { required: "Selecciona tu municipio de residencia" })}
								onChange={handleDistrito}
							>
								<option value="">Seleccione su municipio</option>
								{municipios.map(function (item, index) {
									return (
										<option key={index} value={item.id}>{item.name}</option>
									);
								})}
							</select>
							{errors.municipio && <span className='text-red-600'>{errors.municipio.message}</span>}
						</div>
						<div className="w-auto mb-2">
							<label className="p-1">Distrito</label>
							<select className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg ${errors.distrito ? 'border-red-600' : ''}`} {...register("distrito", { required: "Selecciona tu distrito de residencia" })}>
								<option value="">Seleccione su distrito</option>
								{distritos.map(function (item, index) {
									return (
										<option key={index} value={item.id}>{item.name}</option>
									);
								})}
							</select>
							{errors.distrito && <span className='text-red-600'>{errors.distrito.message}</span>}
						</div>
					</div>
					<div className='w-auto md:w-1/2 md:mx-2 mb-2'>
						<label htmlFor='mapa'>Selecciona la ubicación de tu domicilio en el siguiente mapa:</label>
						<MapContainer center={[13.6989, -89.1914]} zoom={7} style={{ height: "300px", width: "100%" }}>
							<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
							<CenterMap position={[
								centro.latitude ? parseFloat(centro.latitude) : 13.6989,
								centro.longitude ? parseFloat(centro.longitude) : -89.1914
							]} zoom={7} />
							<SelectLocation setSelectedPosition={setSelectedPosition} />
							{selectedPosition && (
								<Marker position={[selectedPosition.lat, selectedPosition.lng]} icon={customIcon} />
							)}
						</MapContainer>
						{selectedPosition && (
							<div className='flex flex-row justify-between'>
								<p>Latitud: {selectedPosition.lat}</p>
								<p>Longitud: {selectedPosition.lng}</p>
							</div>
						)}
						{location && <span className='text-red-600'>
							Selecciona la ubicación en el mapa
						</span>}
					</div>
				</div>
				<div className="flex flex-col md:flex-row justify-start w-auto px-2">
					<div className="w-auto md:mr-2 md:w-1/3 mb-2">
						<label htmlFor='dui' className="p-1">Ingresa tu número de DUI</label>
						<input type="tel" placeholder="DUI (########-#)" inputMode='numeric' maxLength='9' name='dui' id='dui' className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg ${errors.dui ? 'border-red-600' : ''}`} {...register("dui", {
							required: {
								value: true,
								message: "Debes ingresar tu numero de DUI"
							}
						})} onChange={(event) => {
							const { value } = event.target
							event.target.value = validarDui(value)
						}} />
						{errors.dui && <span className='text-red-600'>{errors.dui.message}</span>}
					</div>
					<div className="w-auto md:mx-2 md:w-1/3 mb-2">
						<label className="p-1">Correo electrónico</label>
						<input id="" placeholder="Ingresa tu correo electrónico (alguien@ejemplo.com)" className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg ${errors.correo ? 'border-red-600' : ''}`} type="email" {...register("correo", {
							required: {
								value: true,
								message: "Ingresa un correo electrónico"
							},
							pattern: {
								value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
								message: "Correo no válido"
							}
						})} />
						{errors.correo && <span className='text-red-600'>{errors.correo.message}</span>}
					</div>
					<div className="w-auto md:mx-2 md:w-1/3 mb-2">
						<label className="p-1">Área de trabajo</label>
						<select className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg ${errors.area_trabajo ? 'border-red-600' : ''}`} {...register("area_trabajo", { required: "Selecciona tu área de trabajo" })}>
							<option value="">Área de trabajo</option>
							<option value="administrativo">Administrativo</option>
							<option value="operativo">Operativo</option>
							<option value="mandoMedio">Mando Medio</option>
							<option value="limpieza-mantenimiento">Limpieza/Mantenimiento</option>
							<option value="ventas">Ventas</option>
						</select>
						{errors.area_trabajo && <span className='text-red-600'>{errors.area_trabajo.message}</span>}
					</div>
				</div>
				<h1 className="text-3xl md:text-3xl mt-3 md:mt-6 text-[#0D7F9F] mb-1">
					Información general del cónyuge
				</h1>
				<div className="flex flex-col md:flex-row p-2">
					<div className="w-auto md:w-1/2 md:mr-2 mb-2">
						<label className="">Nombre del cónyuge</label>
						<input id="" placeholder="Nombre del cónyuge" className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg ${errors.nombre_conyugue ? 'border-red-600' : ''}`} type="text" {...register("nombre_conyugue", {
							required: {
								value: true,
								message: "El nombre es requerido"
							},
							pattern: {
								value: /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g,
								message: "El nombre introducido no es correcto"
							}
						})} />
						{errors.nombre_conyugue && <span className='text-red-600'>{errors.nombre_conyugue.message}</span>}
					</div>
					<div className="w-auto md:mx-2 md:w-1/4 mb-2">
						<label className="">Sexo</label>
						<select className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg ${errors.sexo_conyugue ? 'border-red-600' : ''}`} {...register("sexo_conyugue", { required: "Selecciona el sexo de tu cónyuge" })}>
							<option value="">Selecciona el sexo</option>
							<option value="Masculino">Masculino</option>
							<option value="Femenino">Femenino</option>
						</select>
						{errors.sexo_conyugue && <span className='text-red-600'>{errors.sexo_conyugue.message}</span>}
					</div>  
					<div className="w-auto md:mx-2 md:w-1/4 mb-2">
						<label className="">Fecha de Nacimiento</label>
						<input id="" className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg ${errors.nacimiento_conyugue ? 'border-red-600' : ''}`} type="date" {...register("nacimiento_conyugue",
							{
								required: {
									value: true,
									message: "La fecha de nacimiento de tu cónyuge es requerida"
								},
								validate: value => {
									const nacimiento_conyugue = new Date(value);
									const fechaActual = new Date();
									const edad = fechaActual.getFullYear() - nacimiento_conyugue.getFullYear();
									return edad >= 18 || "Tu cónyuge debe ser mayor de edad"
								}
							})} />
						{errors.nacimiento_conyugue && <span className='text-red-600'>{errors.nacimiento_conyugue.message}</span>}
					</div>
				</div>
				<div className="flex flex-col md:flex-row px-2 justify-between w-auto items-end">
					<div className={`md:mr-2 w-full md:w-1/2 border-2 p-2 mb-2 flex flex-row md:flex-col justify-between h-auto items-center bg-[#D1ECF2] rounded-lg ${errors.trabaja_conyugue ? 'border-red-600' : ''}`} id="grupo__nombre">
						<label htmlFor="trabaja_conyugue">¿El cónyuge se encuentra trabajando? </label>
						<div className="flex flex-row items-center justify-between w-[100px] h-2/3 font-normal ">
							<label>
								<input type="radio" value="si" {...register("trabaja_conyugue", { required: "Elige una respuesta" })} />Si</label>
							<label>
								<input type="radio" value="no" {...register("trabaja_conyugue", { required: "Elige una respuesta" })} />No</label>
						</div>
						{errors.trabaja_conyugue && <span className='text-red-600 w-full px-2 flex justify-center'>{errors.trabaja_conyugue.message}</span>}
					</div>
					<div className="md:mx-2 md:w-1/2 mb-2">
						<label className="p-1">Nombre de la Empresa (si no trabaja, dejar vacío)</label>
						<input type='text' className='w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg' placeholder='Empresa donde trabaja tu cónyuge' {...register("empresa_conyugue")} />
					</div>
				</div>
				<div className="w-auto items-end px-2 mb-2">
					<div className='flex flex-row justify-between p-2 items-center my-2 border-2 bg-[#D1ECF2] rounded-lg'>
						<label className='font-semibold'>
							¿Tú o tu cónyuge se encuentran en estado de embarazo?
						</label>
						<div className="flex justify-between w-[100px]">
							<label>
								<input type="radio" value="si" {...register("embarazo_conyugue")} />
								Si
							</label>
							<label>
								<input type="radio" value="no" {...register("embarazo_conyugue")} />
								No
							</label>
						</div>
					</div>
					{errors.embarazo_conyugue && <span className='text-red-600 w-full px-2 flex justify-end'>{errors.embarazo_conyugue.message}</span>}
					<div className='flex flex-row justify-between p-2 mb-2 items-center my-2 border-2 bg-[#D1ECF2] rounded-lg'>
						<label className='font-semibold'>¿Están planeando tener un bebé?</label>
						<div className="flex justify-between w-[100px]">
							<label>
								<input type="radio" value="si" {...register("parto_conyugue")} />
								Si
							</label>
							<label>
								<input type="radio" value="no" {...register("parto_conyugue")} />
								No
							</label>
						</div>
					</div>
					<div className="flex flex-row justify-between mb-2 p-2 items-center my-2 border-2 bg-[#D1ECF2] rounded-lg">
						<label htmlFor="bebe_conyugue" className="text-base font-semibold">¿Cuál es la fecha probable de parto? (Si no aplica, dejar vacío)</label>
						<input id="bebe_conyugue" className="border bg-[#A9DDE9] p-1 rounded-xl w-[150px]" type="date" {...register("bebe_conyugue")} />
					</div>
					<div className={`flex flex-row justify-between p-2 mb-2 items-center my-2 border-2 bg-[#D1ECF2] rounded-lg ${errors.hijos_conyugue ? 'border-red-600' : ''}`}>
						<label className='font-semibold'>¿Tienes hijos?</label>
						<div className="flex justify-between w-[100px]">
							<label>
								<input type="radio" value="si" {...register("hijos_conyugue", { required: "Elige una respuesta" })} />Si
							</label>
							<label>
								<input type="radio" value="no" {...register("hijos_conyugue", { required: "Elige una respuesta" })} />
								No
							</label>
						</div>
					</div>
					{errors.hijos_conyugue && <span className='text-red-600 w-full px-2 flex justify-end'>{errors.hijos_conyugue.message}</span>}
				</div>
				<div className="flex justify-end pt-2 mr-2">
					<div className='w-[200px] justify-between flex flex-row'>
						<Link to="/Inicio" data-discover="true">
							<button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white rounded-full w-[50px] h-[50px] p-[12px]"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
						</Link>
						<button type="submit" className="bg-[#99C33E] font-medium drop-shadow-2xl shadow-2xl text-white rounded-full w-[125px] h-[50px] p-[12px]">Continuar</button>
					</div>
				</div>
			</form>
		</div>
	)
}

export default FormularioDatosTrabajador;
